const config = {
  wordPressUrl: `https://broadgate-staging.co.uk`,
}

export default config
